export const CORPORATE_LEAD = "CORPORATE_LEAD";
export const APARTMENT_LEAD = "APARTMENT_LEAD";
export const ALLIANCE = "ALLIANCE";
export const SUPPLY = "SUPPLY";
